import { getConfigValue } from '../config';

export function getBaseUrl() {
	return `https://${getConfigValue('HOST')}`;
}

export function getUrl(path: string, id?: string) {
	return `${path.startsWith('http') ? '' : getBaseUrl()}${path}${id ? `#${id}` : ''}`;
}
